import React from "react";
import { EaseDrawer } from "../../../libs/EaseDrawer";
import { Text1 } from "../../../styles";
import { Descriptions } from "antd";
import './index.scss';
import { BUSINESS_ENTITY_TYPE } from "../../../constants";


const MerchantDetailsDrawer = (props) => {
    const { merchant } = props;
    const merchant_profile = merchant.profile || {};

    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>Merchant Details</Text1>
            </div>
        )
    };

    const renderBasicDetails = () => {
        return (
            <Descriptions className="mb-4" title="Basic Details" column={1} size="small" bordered>
                <Descriptions.Item label="Merchant Name">{merchant.name || "---"}</Descriptions.Item>
                <Descriptions.Item label="Email ID">{merchant.email || "---"}</Descriptions.Item>
                <Descriptions.Item label="Phone">{merchant.phone || "---"}</Descriptions.Item>
            </Descriptions>
        )
    };

    const renderBusinessDetails = () => {
        return (
            <Descriptions className="mb-4" title="Business Details" column={1} size="small" bordered>
                <Descriptions.Item label="Business Name">{merchant_profile.business_name || "---"}</Descriptions.Item>
                <Descriptions.Item label="Nature of Business">{(merchant_profile.entity_type === 0 || merchant_profile.entity_type > 1) ? BUSINESS_ENTITY_TYPE[merchant_profile.entity_type].entity_type_label : "---"}</Descriptions.Item>
            </Descriptions>
        )
    };

    const renderBankDetails = () => {
        return (
            <Descriptions className="mb-4" title="Bank Details" column={1} size="small" bordered>
                <Descriptions.Item label="Name On Bank">{merchant_profile.name_on_bank || "---"}</Descriptions.Item>
                <Descriptions.Item label="Bank Name">{merchant_profile.bank_name || "---"}</Descriptions.Item>
                <Descriptions.Item label="Bank Branch">{merchant_profile.bank_branch || "---"}</Descriptions.Item>
                <Descriptions.Item label="Account Number">{merchant_profile.account_number || "---"}</Descriptions.Item>
                <Descriptions.Item label="IFSC Code">{merchant_profile.account_ifsc || "---"}</Descriptions.Item>
            </Descriptions>
        )
    };

    const renderinstantOnboardingDetails = () => {
        {console.log('merchant_profile :>> ', merchant_profile)}
        return (
            <Descriptions className="mb-4" title="KYC Details" column={1} size="small" bordered>
                <Descriptions.Item label="Size">{merchant_profile?.size_type || "---"}</Descriptions.Item>
                <Descriptions.Item label="Genre">{merchant_profile?.genre || "---"}</Descriptions.Item>
                <Descriptions.Item label="Domain ">{merchant_profile?.domain || "---"}</Descriptions.Item>
                <Descriptions.Item label="Subdomain ">{merchant_profile?.subdomain || "---"}</Descriptions.Item>
                <Descriptions.Item label="Business Type Code ">{merchant_profile?.business_type_code || "---"}</Descriptions.Item>
            </Descriptions>
        )
    };

    return (
        <EaseDrawer
            className="merchant-details-wrapper"
            title={false}
            width={450}
            visible={props.visible}
            onClose={props.toggleDetailsDrawer}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <div className="mt-3">
                {renderTitle()}
                {renderBasicDetails()}
                {renderBusinessDetails()}
                {renderBankDetails()}
                {renderinstantOnboardingDetails()}
                {/* {renderKYCDetails()} */}
            </div>

        </EaseDrawer>
    )
};

export { MerchantDetailsDrawer };